document.addEventListener('DOMContentLoaded', function () {
    const a_list = this.documentElement.querySelectorAll('.article__nav a');
  
    a_list.forEach(nav_link => {
      // article nav link click event
      nav_link.addEventListener('click', (e) => {
        e.preventDefault();
        const id = nav_link.dataset.id;
        const h2 = this.documentElement.querySelector(`.article__content h2#${id}`);
        const headerHeight = document.querySelector('[data-header-height]').clientHeight;
        const elementPosition = h2.getBoundingClientRect().top + window.scrollY - headerHeight - 10;
        window.scrollTo({
          top: elementPosition,
          behavior: "smooth"
        });
      })
    })
  
  })
  
  function handlelize (str) {
    str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '') // Remove accents
      .replace(/([^\w]+|\s+)/g, '-') // Replace space and other characters by hyphen
      .replace(/\-\-+/g, '-')	// Replaces multiple hyphens by one hyphen
      .replace(/(^-+|-+$)/g, '') // Remove extra hyphens from beginning or end of the string
      .toLowerCase(); // To lowercase
  
    return str
  };